module.exports = __webpack_public_path__ + "img/快捷实施select.8e35ec96.svg";